import Vue, { PropType } from 'vue';
import { Puzzle } from 'js/crossword/Puzzle';
import { ClueType, CopyrightPlacement } from 'js/crossword/types';
import { LayoutType } from 'js/crossword/gameSceneLayouts';
import { ISettingsData } from 'js/crossword/settingsData';
import { resizeMainArea } from 'js/crossword/html/resizeMainArea';
import ResizeObserver from 'resize-observer-polyfill';
import { onFreezeChanged, isFrozen } from 'js/main';
import OS from 'framework/utils/OS';
import { getCopyrightData } from "../helpers/copyright";
import Board from "./Board";

Vue.component('puzzle-game-area-arrow', {
  props: {
    puzzle: Puzzle,
    settings: Object as PropType<ISettingsData>,
    ui: Object,
  },
  mounted() {
    const gameResizeObserver = new ResizeObserver(() => this.resizeGame());
    gameResizeObserver.observe(this.$refs.boardContainer as HTMLElement);
    this.resizeGame();

    const resizeObserver = new ResizeObserver(() => this.onResize());
    this.onResize();

    resizeObserver.observe(this.$refs.mainArea as HTMLElement);
    this.resizeMainArea();
    onFreezeChanged.add(() => this.resizeMainArea());
    window.addEventListener('resize', () => this.resizeMainArea());
  },
  // computed: {
  //   layoutClass(): string {
  //     if (OS.desktop) {
  //       return {
  //         [LayoutType.RightOneColumn]: 'gameScene__mainArea--oneRight',
  //         [LayoutType.RightTwoColumns]: 'gameScene__mainArea--twoRight',
  //         [LayoutType.LeftOneColumn]: 'gameScene__mainArea--oneLeft',
  //         [LayoutType.LeftTwoColumns]: 'gameScene__mainArea--twoLeft',
  //       }[this.settings.layout];
  //     } else {
  //       return 'gameScene__mainArea--mobile';
  //     }
  //   },
  // },
  methods: {
    zoomBoardIn() {
      this.$refs.board.zoomIn();
    },
    zoomBoardOut() {
      this.$refs.board.zoomOut();
    },
    resizeMainArea() {
      // resizeMainArea({
      //   mainArea: this.$refs.mainArea as HTMLElement,
      //   clueBar: this.$refs.clueBar.$el as HTMLElement,
      //   boardRatio: this.puzzle.getBoardWidth() / this.puzzle.getBoardHeight(),
      //   settings: this.settings,
      //   boardColumn: this.$refs.boardColumn as HTMLElement,
      //   gameScene: document.getElementById('gameScene'),
      //   freeze: isFrozen(),
      // });
    },
    resizeGame() {
      const containerWidth = (this.$refs.boardContainer as HTMLElement).clientWidth;
      const containerHeight = (this.$refs.boardContainer as HTMLElement).clientHeight;
      const containerRatio = containerWidth / containerHeight;
      const boardRatio = this.puzzle.data.columns / this.puzzle.data.rows;

      if (containerRatio > boardRatio) {
        const boardWidth = containerHeight * boardRatio;
        this.$refs.board.resize(boardWidth, containerHeight);
      } else {
        this.$refs.board.resize(containerWidth, containerWidth / boardRatio, 0);
      }
    },
    onResize() {
      if (!OS.desktop) return;
    },
  },
  render() {
    const copyright = getCopyrightData(this.puzzle.data.metaData.format);

    return (
      <div id='gameScene__mainArea' ref='mainArea'>
        <div id='gameScene__boardContainer' ref='boardContainer'>
          <Board puzzle={this.puzzle} ref='board'/>
          
          { copyright.placement === CopyrightPlacement.BOARD 
            ? <div class="board--copyright">{ copyright.message }</div>
            : null }
        </div>
      </div>
    );
  },
});
